{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "generatedFrom": "Pricing Master (TARGET VALUES - regenerate at publish)",
  "currency": "USD",
  "entries": {
    "pb-included": {
      "basis": [
        "INCLUDED"
      ],
      "headline": "Included with every aviOS product",
      "considerations": []
    },
    "intelligence": {
      "basis": [
        "PER_CREDIT"
      ],
      "headline": "No minimum · from 2.5¢ per credit",
      "subline": "Pay only for the AI you use.",
      "considerations": [
        {
          "factor": "AI usage",
          "detail": "Billed per credit, 2.5¢ list. Card on file; On Account available for approved customers."
        },
        {
          "factor": "Activity type",
          "detail": "Questions, document processing, and transcription use different credit amounts."
        },
        {
          "factor": "Volume",
          "detail": "Committed credit packs available at reduced rates."
        }
      ]
    },
    "vault": {
      "basis": [
        "PER_TAIL",
        "PER_CREDIT"
      ],
      "headline": "$899 – $3,599 per aircraft / year",
      "subline": "Varies by aircraft class.",
      "considerations": [
        {
          "factor": "Aircraft class",
          "detail": "Piston through large cabin (B1–B5). Complex aircraft: Contact us."
        },
        {
          "factor": "Included AI credits",
          "detail": "First-year credits included per tail (5,000–15,000 by class); expire after year one."
        },
        {
          "factor": "Additional AI usage",
          "detail": "From 2.5¢ per credit, billed as you go."
        },
        {
          "factor": "Storage",
          "detail": "Allowance included; additional storage available."
        },
        {
          "factor": "Onboarding",
          "detail": "Records migration and setup quoted in your estimate."
        }
      ]
    },
    "operate": {
      "basis": [
        "PER_TAIL",
        "PER_CERTIFICATE"
      ],
      "headline": "From $1,500 per aircraft / year, plus Vault",
      "subline": "Varies by aircraft class and operating profile.",
      "considerations": [
        {
          "factor": "Aircraft class",
          "detail": "Operate extension $1,500–$7,200 per tail/year (B1–B5)."
        },
        {
          "factor": "Operating profile",
          "detail": "Part 135 and management companies may have an annual minimum."
        },
        {
          "factor": "Fleet size",
          "detail": "Volume pricing for larger fleets."
        },
        {
          "factor": "Regulatory scope",
          "detail": "A025 readiness priced per certificate, from $7,500."
        },
        {
          "factor": "AI credits",
          "detail": "Included pool; additional usage from 2.5¢ per credit."
        },
        {
          "factor": "Transaction services",
          "detail": "Conformity, pre-buy, and induction quoted per aircraft."
        }
      ]
    },
    "shop": {
      "basis": [
        "PER_ORGANIZATION",
        "PER_USER",
        "PER_SITE"
      ],
      "headline": "From $299 / month",
      "subline": "Shop Independent from $299 · Shop Standard from $599",
      "considerations": [
        {
          "factor": "Users",
          "detail": "Operational users $89/mo · professional users $39/mo above included. Customer participants included."
        },
        {
          "factor": "Sites",
          "detail": "Additional administered site $249/mo."
        },
        {
          "factor": "Tier",
          "detail": "Specialty and Enterprise: Contact us."
        },
        {
          "factor": "AI usage",
          "detail": "Included allowance; additional usage from 2.5¢ per credit."
        },
        {
          "factor": "Regulatory scope",
          "detail": "Electronic-signoff readiness priced per certificate."
        },
        {
          "factor": "Onboarding",
          "detail": "Migration and configuration quoted in your estimate."
        }
      ]
    },
    "forge": {
      "basis": [
        "PER_PACKAGE",
        "CUSTOM"
      ],
      "headline": "Contact us · services from ~$2,500",
      "subline": "Scoped to what you build or connect.",
      "considerations": [
        {
          "factor": "BUILD",
          "detail": "BYOM, Co-Build, and Network capabilities scoped through discovery."
        },
        {
          "factor": "CONNECT",
          "detail": "Standard integrations and migrations from fixed packages."
        },
        {
          "factor": "Governance review",
          "detail": "Regulated workflows require review before activation."
        }
      ]
    }
  },
  "aiCreditExplainer": {
    "title": "How AI credits work",
    "points": [
      "Routine work, signoffs, and records: never charged",
      "AI questions, document processing, and transcription use credits",
      "Credits included with each aircraft or subscription",
      "Usage beyond the allowance billed as you go"
    ],
    "examples": [
      {
        "activity": "Ask AI question",
        "approx": "~10¢"
      },
      {
        "activity": "Document page ingested",
        "approx": "~7.5¢"
      },
      {
        "activity": "Voice / call minute",
        "approx": "~25¢"
      }
    ]
  },
  "extensionPricing": {
    "ext-conformity-review": "From $3,500",
    "ext-prebuy": "From $3,500",
    "ext-a025-readiness": "From $7,500 per certificate",
    "ext-data-migration": "From $2,500",
    "ext-integrations": "From $2,500",
    "ext-workflow-extensions": "From $2,500",
    "ext-premium-support": "From $500 / month",
    "ext-byom": "Contact us",
    "ext-co-build": "Contact us",
    "ext-ironfleet-network": "Contact us",
    "ext-esign-readiness": "Contact us",
    "ext-wearable-inspection": "Contact us",
    "ext-records-audit": "From $2,500"
  }
}